<script>
import CountriesApi from "@/services/countries-api";
import CustomerApi from "@/services/customers-api";
import Swal from "sweetalert2";


export default {
      components: {},
  data() {
    return {
        customersList:[],
        customersFilter:null,
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        customersListFields: 
            [
                
                { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},

                { key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"city", label: "",   thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none"},
                { key:"phone", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"address", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"users", label: "",thClass:"text-center", tdClass:"text-center"},           
                { key:"status", label: "",thClass:"text-center", tdClass:"text-center"},

                { key:"actions", label:""}
            ],
        type:null,
        isCustomersTableBusy:false,
        showDetailsModal:false,
        citiesList:[],
        countriesList:[],
        selectedCountry:null,
        selectedCity:null,
        selectedCustomerCountry:null,
        selectedCustomerCity:null,
        selectedUser:{id:'',name:'',mail:'',password:'',supplierId:null,status:1,companyName:'' , address:''  },

        selected:{country:"",city:""},    
        note:null,
        noteList:null,

        showAddCustommerModal: false,
      }
      
    },

    
  mounted() {
    this.findCustomers()
    this.getCountries()
  },

  methods: {

    openDetailsModal(item){
        this.getNoteByCustomer()
        this.selected=item
        this.showDetailsModal=true
    },


    saveCustomer(){

         const newCustomer = {
            customerId: this.selectedUser.id,
            name: this.selectedUser.name,
            userName: this.selectedUser.mail,
            status: this.selectedUser.status,
            countryId: this.selectedCustomerCountry == null ? null : this.selectedCustomerCountry.id,
            cityId: this.selectedCustomerCity == null ? null : this.selectedCustomerCity.id,
            phone: this.selectedUser.phone,
            address: this.selectedUser.address,
            companyName: this.selectedUser.companyName,
        }
        CustomerApi.saveCustomer(newCustomer).then(response => {
            if(response){
                this.customersList= response.list
                this.pagemodelMain.totalRows = response.total;
                this.pagemodelMain.currentPage = response.page;
                this.pagemodelMain.perPage = response.pageSize;
                this.pagemodelMain.pageSize = response.pageSize;  

                this.showAddCustommerModal = false ;
            }
        }) 


    },

    addNewCustomer(){
        this.selectedUser = {}
        this.selectedCustomerCountry = null
        this.selectedCustomerCity = null
        this.showAddCustommerModal = true

    },
    editCustomer(customer){
        this.showAddCustommerModal = true
        this.selectedUser = customer
        this.selectedCustomerCountry = customer.country
        this.selectedCustomerCity = customer.city

    },

    deleteCustomer(customer){

        if(customer == null){
            return
        }

        Swal.fire({
              title: "Supprimer le client " + customer.companyName + " !",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#d11010",
              confirmButtonText: "Oui, supprimer",
              cancelButtonText: "Annuler",
            }).then((result) => {
              if (result.value) {
                CustomerApi.deleteCustomer( this.pagemodelMain.currentPage, this.pagemodelMain.perPage, customer.id).then(
                    response => {
                        if(response) {
                        this.customersList= response.list
                        this.pagemodelMain.totalRows = response.total;
                        this.pagemodelMain.currentPage = response.page;
                        this.pagemodelMain.perPage = response.pageSize;
                        this.pagemodelMain.pageSize = response.pageSize;
                    }   
                    }
                )
              }
            });



    },


    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
       CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
          result => {
            this.citiesList = result
        })
     },

     getCustomerCities(){
       CountriesApi.getCities(this.selectedCustomerCountry ? this.selectedCustomerCountry.id : null).then(
          result => {
            this.citiesList = result
        })
     },
    
    
    findCustomers(){
          this.isCustomersTableBusy = true;
              CustomerApi.getAllCustomersWithUsersCount(this.customersFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedCountry ? this.selectedCountry.id : null,this.selectedCity ? this.selectedCity.id : null).then(
                  response => {
                      if(response) {
                        this.customersList= response.list
                        this.pagemodelMain.totalRows = response.total;
                        this.pagemodelMain.currentPage = response.page;
                        this.pagemodelMain.perPage = response.pageSize;
                        this.pagemodelMain.pageSize = response.pageSize;
                    }   
                  }
              )
              .finally(() => {
             this.isCustomersTableBusy = false;

      });
    },

    deliveryModeToLabel(deliveryMode){
      switch(deliveryMode) {
        case 0: return 'supplier';
        case 1: return 'carrier';
        default: return 'supplier';
      }
    },



},

    watch: {
        selectedCountry: function(){
          if(this.selectedCountry != null){
            this.getCities()
          }else{
              this.citiesList=[]
          }
            this.findCustomers()
        },

        selectedCity: function(){
            this.findCustomers()

        },

        selectedCustomerCountry: function(){
          if(this.selectedCustomerCountry != null){
            this.getCustomerCities()
          }else{
              this.citiesList=[]
          }
            this.findCustomers()
        },
    }



};
</script>
<style>

    .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>


    



    <div class="row pt-4 mt-4">    
      <div class="col-sm-12">
        <div class="">
          <div class="">
           

            <div class="row p-0 m-0 pb-4 mt-0 ">
                <div class ="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <b-form-group :label="$t('subscription.nameFilter.label')" >
                        <b-input-group  >
                            <b-form-input :placeholder="$t('subscription.nameFilter.placeholder')"   v-model="customersFilter"   @keyup.native.enter="findCustomers() "
                                ></b-form-input>                              
                            <template v-slot:append>
                                <b-button variant="primary" @click="findCustomers()" >
                                <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                                </b-button>
                            </template>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <b-button variant="outline-primary" @click="addNewCustomer()" class="mb-4 float-right">
                        <i class="  fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                        <span class="  font-weight-bold">
                        {{$t('users.addNewCustomer')}}  
                        </span>
                    </b-button>
                </div>
             
            </div>

            <div class="row">
            <div class ="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <b-form-group :label="$t('lists.countries.filter')" label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="countriesList" :placeholder="$t('lists.countries.label')"  label="name" v-model="selectedCountry">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-0">
                    <b-form-group :label="$t('lists.cities.filter')"  label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
            </div>

            <div class="table-responsive"> 
                <b-table 
                :busy="isCustomersTableBusy"
                :striped="true"
                :small="false"
                :hover="true"
                :items="customersList"
                :fields="customersListFields"
                :perPage="pagemodelMain.perPage"
                class="table  "
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>
                <template v-slot:head(companyName)>
                    {{ $t("subscription.table.name") }} 
                </template>
                <template v-slot:head(country)>
                    {{ $t("subscription.table.country") }} 
                </template>
                <template v-slot:head(city)>
                    {{ $t("subscription.table.city") }} 
                </template>
                <template v-slot:head(extId)>
                    {{ $t("subscription.table.code") }} 
                </template>
                <template v-slot:head(phone)>
                    {{ $t("subscription.table.phone") }} 
                </template>
                <template v-slot:head(status)>
                    {{ $t("subscription.table.active") }}  
                </template>
                <template v-slot:head(users)>
                    {{ $t("subscription.table.users") }} 
                </template>
                <template v-slot:head(address)>
                   {{$t('subscription.detailsModal.address')}}
                </template>
                <template v-slot:cell(status)="{value}">
                    <i :class="value===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
                </template>

                <template v-slot:cell(country)="{value}">
                    {{value.name}}
                </template>
                
                <template v-slot:cell(city)="{value}">
                    {{value.name}}
                </template>

                <template v-slot:cell(users)="{item}">
                    <a :href="'/customer-utilisateurs?id=' + item.id">
                        {{ item.usersCount }} utilisateur(s)
                        </a>
               </template>
               <template v-slot:cell(actions)="{ item }">
                    <div class="d-flex float-right align-items-center">


                        <router-link :to="{ path: '/customer-info', query: { customerId: item.id } }">
                            <b-button  size="sm"  class="bg-light" variant="outline-info" >
                                <img :title="$t('subscription.showDetails')" alt="View details" width="20px" src="@/assets/icons/info.svg" style="cursor: pointer; "/>
                            </b-button> 
                        </router-link>
                        
                        <b-button  size="sm"  class="bg-light ml-2" variant="outline-info" @click="editCustomer(item)">
                            <img alt="Edit customer" width="20px" src="@/assets/icons/pencil.svg" style="cursor: pointer;"  @click="editCustomer(item)"/>
                        </b-button> 
                        <b-button  size="sm"  class="bg-light ml-2" variant="outline-info" @click="deleteCustomer(item)">
                            <img  alt="Delete customer" width="20px"  src="@/assets/icons/trash.svg" style="cursor: pointer;" />
                        </b-button> 


                    </div>
                </template>

                </b-table>
                <span v-if="!isCustomersTableBusy & !customersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("subscription.table.empty")}}</span>
            </div>
            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="findCustomers()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodelMain.currentPage" :disabled="isCustomersTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findCustomers()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->
            

          </div>
        </div>
      </div>

      <b-modal
                v-model="showAddCustommerModal"
                :title="selectedUser.id ? $t('customers.editCustomerModal.title1') : $t('customers.editCustomerModal.title2') " 
                centered 
                title-class="text-primary"
                title-tag="h5"
                header-close-variant="danger"
                size="lg"
                no-close-on-backdrop
        >

            <div class="row">

                <div class="col-12 col-sm-6">
                    <div class="float-left">
                        <div  class="form-group  ">
                            <b-form-checkbox
                                value="1"
                                unchecked-value="0"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                v-model="selectedUser.status"
                                >   
                                <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-info' : 'text-muted'">{{selectedUser.status == 1 ? $t('customers.editCustomerModal.status.active') : $t('users.editUsersModal.status.disabled')}}</span>
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>
            

            </div>

            <div class="row mt-4">
            <div class ="col-sm-4 pr-2">
                    <b-form-group :label="$t('subscription.detailsModal.country')" label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="countriesList" :placeholder="$t('lists.countries.label')"  label="name" v-model="selectedCustomerCountry">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="col-sm-4 pr-2">
                    <b-form-group :label="$t('subscription.detailsModal.city')"  label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCustomerCity">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
            </div>

            <div class="row " style="width:100%">
                <div class="form-group col-sm-4 pr-2">
                    <label >Nom </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.companyName"
                    />
                </div>
                
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('profil.organization.mail')}} </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.mail"

                    />
                </div>

                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('users.editUsersModal.table.phone')}}</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.phone"

                    />
                </div>
                <div class="form-group col-sm-8 pr-2">
                    <b-form-group :label="$t('subscription.detailsModal.address')" label-for="">
                        <textarea v-model="selectedUser.address" class="form-control font-size-14" :maxlength="300" rows="3"></textarea> 
                    </b-form-group>
                </div>

            </div>


            



            <template v-slot:modal-footer>
            <!-- <b-button variant="secondary" @click="editUsersModal = false" size="md">{{$t('buttons.cancel')}}</b-button> -->
            <b-button  variant="primary" @click="saveCustomer()" size="md" ><span class="text-white text-uppercase font-weight-bold">{{$t('buttons.save')}}</span></b-button>
            </template>

        </b-modal>
       



    </div>


</template>